export const NO_LOGO_SELECTED = 'NO_LOGO_SELECTED'
export const YANDLE_MARK_PUBLIC_PATH = '/yandle-mark.svg'

export function isNoLogoSelected(key) {
  return String(key ?? '').trim().toUpperCase() === NO_LOGO_SELECTED
}

export function resolveOrgLogoS3Key(org) {
  if (!org || typeof org !== 'object') return ''
  return String(
    org.org_logo_s3_key ??
      org.logo_s3_key ??
      org.logo_s3key ??
      org.org_logo ??
      '',
  ).trim()
}

export function resolveOrgLogoFallback(key) {
  if (isNoLogoSelected(key)) return YANDLE_MARK_PUBLIC_PATH
  return null
}
